var cov_ok9hxkvpu = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/index.ts",
      hash = "db53fd37b79bf6bbdd845fca75d9bdc55a4ad93d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 9,
          column: 36
        }
      },
      "1": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 13,
          column: 8
        }
      },
      "2": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 15,
          column: 37
        }
      },
      "3": {
        start: {
          line: 16,
          column: 0
        },
        end: {
          line: 16,
          column: 48
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import inputable from '../Form/inputable';
import Datum from '../Datum';
import { consumer } from '../Checkbox/context';
import Group from './Group';
import Radio from './Radio';
var exports = (cov_ok9hxkvpu.s[0]++, consumer(Radio));
cov_ok9hxkvpu.s[1]++;
exports.Group = compose(inputable, Datum.hoc({
  limit: 1,
  bindProps: ['disabled', 'format', 'prediction'],
  pure: false
}))(Group);
cov_ok9hxkvpu.s[2]++;
exports.displayName = 'ShineoutRadio';
cov_ok9hxkvpu.s[3]++;
exports.Group.displayName = 'ShineoutRadioGroup';
export default exports;